import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React from 'react';
import { View, Text as RNText } from 'react-native';
import { Message } from '../../Message/rn';
import { Text } from '../../Text/rn';
import CorrectSvg from '../../../assets/images/rn/Correct';
import { CustomStyleSheet, getScaledPx } from '../../../utils/rn/tools'; // @ts-ignore

import Parser from 'html-parse-stringify2';
import { BubbleInnerWidth, FONT_WEIGHT_MEDIUM } from '../../../styles/rn';
function getType(value) {
  return Object.prototype.toString.call(value).slice(8, -1);
}
function recursion(obj) {
  obj.attrs = obj.attrs || {};
  obj.attrs.style = "color: ".concat(style['milestone-item__future'].color, " !important");
  if (obj.name === 'a') {
    obj.attrs.href = 'javascript: void(0);';
  }
  if (obj.children) {
    obj.children.forEach(function (el) {
      return recursion(el);
    });
  }
}
export var Milestone = function Milestone(props) {
  var milestoneRichtextSizes = props.milestoneRichtextSizes,
    debounceSizeChange = props.debounceSizeChange;
  var milestones = props.milestones.map(function (v) {
    var _v$description;

    // 文字置灰处理
    if (v.description && (v.isFuture || props.disabled)) {
      var ast = Parser.parse(v.description.content);
      ast.forEach(function (el) {
        return recursion(el);
      });
      var str = Parser.stringify(ast);
      v.description.content = str;
    }
    if ((_v$description = v.description) !== null && _v$description !== void 0 && _v$description.buttonGroup) {
      if (v.isFuture || props.disabled) {
        v.description.buttonGroup.disabled = true;
        v.description.disableSpecialLink = true;
        v.description.buttonGroup.buttons.forEach(function (btn) {
          btn.disabled = true;
        });
      }
      if (!v.description.buttonGroup.styles) {
        v.description.buttonGroup.styles = style['milestone-button-group'];
      } else {
        if (getType(v.description.buttonGroup.styles) === 'Array') {
          v.description.buttonGroup.styles = [v.description.buttonGroup.styles, style['milestone-button-group']];
        } else if (getType(v.description.buttonGroup.styles) === 'Object') {
          Object.keys(style['milestone-button-group']).forEach(function (key) {
            // @ts-ignore
            v.description.buttonGroup.styles[key] = style['milestone-button-group'][key];
          });
        }
      }
      v.description.buttonGroup.buttons.forEach(function (btn) {
        // btn.children = <View style={[style.scale]}>
        //   <RNText style={{ fontSize: 12 }}>{btn.text}</RNText>
        // </View>;
        btn.styles = {
          textStyle: _objectSpread({}, style.scale),
          containerStyle: {// height: 16,
            // justifyContent: 'center',
            // alignItems: 'center',
          }
        };
      });
    }
    return _objectSpread(_objectSpread({}, v), {}, {
      description: v.description
    });
  });
  return /*#__PURE__*/React.createElement(View, {
    style: [style.milestone, props.noBottomPadding && style['milestone__no-padding-bottom']]
  }, milestones.map(function (v, index) {
    var _v$description2;
    return /*#__PURE__*/React.createElement(View, {
      style: style['milestone-item'],
      key: v.dateText
    }, /*#__PURE__*/React.createElement(View, {
      style: style['milestone-item-date']
    }, /*#__PURE__*/React.createElement(RNText, {
      style: [style['item-date-sub-first'], style.text, v.isFuture && style['milestone-item__future']]
    }, v.dateText), v.hintText ? /*#__PURE__*/React.createElement(View, {
      style: style['item-date-sub-last']
    }, /*#__PURE__*/React.createElement(RNText, {
      style: [style.text, v.isFuture && style['milestone-item__future']]
    }, v.hintText)) : null), /*#__PURE__*/React.createElement(Divider, {
      isFuture: v.isFuture
    }), /*#__PURE__*/React.createElement(View, {
      style: style['milestone-item-content']
    }, /*#__PURE__*/React.createElement(Text, {
      content: v.title,
      styles: v.isFuture ? style['future-title'] : style.title
    }), v.description ? /*#__PURE__*/React.createElement(Message, _extends({}, v.description, {
      styles: _objectSpread(_objectSpread({
        containerStyle: style.message
      }, (_v$description2 = v.description) === null || _v$description2 === void 0 ? void 0 : _v$description2.styles), {}, {
        textStyle: {
          color: v.isFuture ? 'rgba(0, 0, 0, 0.26)' : 'rgba(0, 0, 0, 0.87)'
        }
      }),
      className: "message",
      defaultRichTextWidth: milestoneRichTextWidth,
      richTextSize: milestoneRichtextSizes === null || milestoneRichtextSizes === void 0 ? void 0 : milestoneRichtextSizes[index],
      debounceSizeChange: debounceSizeChange
    })) : null));
  }));
};
var Divider = function Divider(props) {
  var isFuture = props.isFuture;
  return /*#__PURE__*/React.createElement(View, {
    style: style['milestone-item-divider']
  }, props.isFuture ? /*#__PURE__*/React.createElement(View, {
    style: style.future
  }) : /*#__PURE__*/React.createElement(View, {
    style: style.past
  }, /*#__PURE__*/React.createElement(CorrectSvg, null)), /*#__PURE__*/React.createElement(View, {
    style: isFuture ? style['future-line'] : style.line
  }));
};
var style = CustomStyleSheet({
  'milestone-button-group': {
    marginRight: 32
  },
  'button-group-view': {
    lineHeight: 16,
    marginLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    borderRadius: 2,
    minWidth: 158
  },
  scale: {
    // height: 16,
    fontSize: 12,
    textAlign: 'center' // transform: [{ scale: 0.75 }],
  },

  milestone: {
    paddingTop: 12,
    paddingRight: 12,
    paddingBottom: 12,
    paddingLeft: 12,
    width: '100%'
  },
  'milestone__no-padding-bottom': {
    paddingBottom: 0
  },
  'milestone-item': {
    flexDirection: 'row',
    alignItems: 'stretch'
  },
  text: {
    color: 'rgba(0, 0, 0, 0.87)',
    textAlign: 'center'
  },
  'milestone-item__future': {
    color: 'rgba(0, 0, 0, 0.26)'
  },
  'milestone-item-date': {
    marginRight: 4,
    paddingBottom: 12,
    width: 40,
    flexGrow: 0,
    flexShrink: 0
  },
  'item-date-sub-first': {
    fontSize: 12,
    lineHeight: 14
  },
  'item-date-sub-last': {
    marginTop: 2,
    lineHeight: 12,
    fontSize: 12,
    transform: [{
      scale: 0.8
    }]
  },
  'milestone-item-content': {
    marginLeft: 12,
    paddingBottom: 12,
    flexShrink: 1
  },
  message: {
    marginTop: 4
  },
  title: _objectSpread(_objectSpread({
    lineHeight: 16
  }, FONT_WEIGHT_MEDIUM), {}, {
    color: 'rgba(0, 0, 0, 0.87)'
  }),
  'future-title': {
    fontWeight: '400',
    color: 'rgba(0, 0, 0, 0.26)'
  },
  'milestone-item-divider': {
    alignItems: 'center'
  },
  future: {
    width: 16,
    height: 16,
    backgroundColor: '#ffffff',
    borderWidth: 1,
    borderColor: 'rgba(0, 0, 0, 0.09)',
    borderRadius: 16
  },
  past: {
    width: 16,
    height: 16,
    backgroundColor: '#ee4d2d',
    borderRadius: 16,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  line: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    borderWidth: 1,
    borderColor: 'rgba(0, 0, 0, 0.09)'
  },
  'future-line': {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    borderWidth: 1,
    borderColor: 'rgba(0, 0, 0, 0.09)',
    borderStyle: 'dashed'
  }
});
export var milestoneRichTextWidth = getScaledPx(BubbleInnerWidth) - style['milestone-item-date'].width - style['milestone-item-date'].marginRight - style.past.width - style['milestone-item-content'].marginLeft - style.milestone.paddingLeft - style.milestone.paddingRight;